import { render, staticRenderFns } from "./Type5.vue?vue&type=template&id=26b9e931&scoped=true"
import script from "./Type5.vue?vue&type=script&lang=js"
export * from "./Type5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b9e931",
  null
  
)

export default component.exports